import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { FixtureCompetitionPage as FixtureCompetitionPageComponent } from '#src/components/FixtureCompetitionPage.tsx';

import type {
  FixtureCompetitionCompetitionPageQuery,
  FixtureCompetitionCompetitionPageQueryVariables,
} from './__generated__/page.graphql.ts';
import type { PageParams } from './__generated__/routeParams.ts';

const FIXTURE_COMPETITION_PAGE_QUERY = gql`
  query FixtureCompetitionCompetitionPageQuery($competition: String!) {
    so5 {
      so5LeaderboardGroupInterface(slug: $competition) {
        slug
        ...FixtureCompetitionPage_so5LeaderboardGroupInterface
      }
    }
  }
  ${FixtureCompetitionPageComponent.fragments.so5LeaderboardGroupInterface}
` as TypedDocumentNode<
  FixtureCompetitionCompetitionPageQuery,
  FixtureCompetitionCompetitionPageQueryVariables
>;

export const loader = queryLoader(
  FIXTURE_COMPETITION_PAGE_QUERY,
  ({ competition }: PageParams) => ({ competition })
);

const FixtureCompetitionPage = () => {
  const { data } = useQueryLoader<FixtureCompetitionCompetitionPageQuery>();
  const { fixture, eventType, competition } = useTypedParams<PageParams>();

  const { so5LeaderboardGroupInterface } = data.so5 || {};

  return (
    <FixtureCompetitionPageComponent
      so5LeaderboardGroupInterface={so5LeaderboardGroupInterface}
      fixture={fixture}
      eventType={eventType}
      competition={competition}
    />
  );
};

export default FixtureCompetitionPage;
